import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "antd";
import Validation from "./Validation";
import "react-phone-number-input/style.css";
import axiosInstance from "../../utils/axiosInstance";
import { useAuth } from "../../context/useAuth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ProfileHoverMenu from "../navbar/ProfileHoverMenu";
import CircularProgressBar, {
  CircularProgressSize,
} from "../CircularProgressBar/CircularProgressBar";
const imgS2 =
  "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/posp-login.png";
const imgS3 =
  "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/posp-signup.png";
const acuLogo =
  "https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/logo+3.png";

function SignIn(props) {
  const { defaultOpen } = props;
  const [isSignUpMode, setIsSignUpMode] = useState(false);
  const { login, user } = useAuth();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // sending otp, verifying otp etc.
  const [seconds, setSeconds] = useState(0);
  const [allowResend, setResend] = useState(true);

  const navigate = useNavigate();
  const [values, setValues] = useState({
    mobile: "",
  });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    gender: "",
    email: "",
    pincode: "",
  });

  const secretKey = process.env.REACT_APP_SECRET_KEY;
  console.log("mayank", secretKey);
  console.log("defaultOpen", defaultOpen);
  console.log("isLoggedIn", isLoggedIn);
  console.log("isSignUpMode", isSignUpMode);

  const [otp, setOtp] = useState("");
  const [open, setOpen] = useState(defaultOpen);
  const [errors, setErrors] = useState({});
  console.log("open", open);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  /** This function handles user details and update it to the customer object */
  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    axiosInstance
      .post("api/customer/update-user", formData)
      .then((res) => {
        setIsLoading(false);
        console.log("update-user", res);
        setOtp(true);
        setIsLoggedIn(true);
        setIsSignUpMode(false);
        login({ user: res?.data?.user });
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err?.response?.data?.message);
        console.log(err);
      });
  };
  // To take input and set state
  const handleInput = (event) => {
    setValues((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  /** This functin validates and sends OTP when user tries signing in. */
  const handleSignInSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = Validation(values);
    setErrors(validationErrors);
    setIsLoading(true);

    // Wait for the state to be updated before checking for errors
    await new Promise((resolve) => setTimeout(resolve, 0));

    if (validationErrors.mobile === "") {
      // Assuming you have an API endpoint to send OTP
      axiosInstance
        .post("/api/customer/send-otp", values)
        .then((res) => {
          console.log(res);
          setIsLoading(false);
          if (res?.data?.success !== undefined && res?.data?.success) {
            setIsOtpSent(true);
            setOtp("");
            toast(res?.data?.message);
          } else {
            alert(res?.data?.message);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("edede", err);
          alert(err?.response?.data?.message);
        });
    }
    setIsLoading(false);
    setSeconds(120);
  };
  // To verify otp for both sign -in and sign up
  const handleOtpSubmit = (event) => {
    setIsLoading(true);
    console.log("in hai");
    event.preventDefault();
    const validationErrors = Validation(values);
    setErrors(validationErrors);
    // Handle OTP verification here if needed
    const reqBody = {
      mobile: values.mobile,
      otp: otp,
    };
    console.log("req", errors.otp);
    // if (errors.otp === "" || undefined) {
    axiosInstance
      .post("/api/customer/verify-otp", reqBody)
      .then((res) => {
        console.log(res);
        setOtp(true);
        setIsLoggedIn(true);
        !isSignUpMode && login({ user: res?.data?.user }); // avoiding while signup
        setIsLoading(false);
        setSeconds(0);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        setErrors((prevError) => ({
          ...prevError,
          // otp: err?.response?.data?.message
          otp: "Invalid OTP",
        }));
      });

    // }
  };

  const handleSignupSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = Validation(values);
    setErrors(validationErrors);

    // Wait for the state to be updated before checking for errors
    await new Promise((resolve) => setTimeout(resolve, 0));
    setIsLoading(true);

    if (validationErrors.mobile === "") {
      try {
        const res = await axiosInstance.post("/api/customer/signup", values);
        setIsLoading(false);
        console.log(res);
        if (res?.data?.success !== undefined && res?.data?.success) {
          setIsOtpSent(true);
          setOtp("");
        } else {
          alert(res?.data?.message);
        }
      } catch (err) {
        setIsLoading(false);
        console.log(err);

        alert(err.response.data.message);
      }
    }
    setIsLoading(false);
    setSeconds(120);
  };

  const switchToSignupMode = () => {
    setIsOtpSent(false);
    setIsSignUpMode((prev) => !prev);
  };

  const switchToMobileEntry = () => {
    setIsOtpSent(false);
    setValues({
      mobile: "",
    });
  };
  console.log("isOtpSent:", isOtpSent);

  const handleModalClose = () => {
    setIsSignUpMode(false);
    setIsOtpSent(false);
    setIsLoggedIn(false);
    setOpen(false);
    if (window.location.pathname === "/signin") navigate(-1);
  };

  const handleOtpInputChange = (index, value) => {
    if (/[0-9]/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;

      if (newOtp.every((digit) => digit !== "") && newOtp.length === 6) {
        const otpString = newOtp.join("");
        setOtp(otpString);
      } else {
        setOtp(newOtp);
      }
      // Automatically focus on the next input field
      const nextIndex = index + 1;
      if (nextIndex < 6) {
        document.getElementById(`otpInput${nextIndex}`).focus();
      } else {
        console.log(`Element with ID otpInput${nextIndex} not found`);
      }
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace key to remove OTP digits
    if (e.key === "Backspace" && index > 0) {
      e.preventDefault(); // Prevent the default backspace behavior

      // Remove the content of the current input
      document.getElementById(`otpInput${index}`).value = "";

      // Move focus to the previous input
      document.getElementById(`otpInput${index - 1}`).focus();
    }
  };

  useEffect(() => {
    if (!isOtpSent || seconds <= 0) return;

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          setResend(false);
          clearInterval(interval); // Stop the timer
          return 0; // Reset to zero
        }
        return prevSeconds - 1; // Decrement timer
      });
    }, 1000);

    return () => {
      clearInterval(interval); // Cleanup on unmount
    };
  }, [isOtpSent, seconds]);

  const handleResendOTP = (e) => {
    e.preventDefault();
    if (seconds > 0) return; // Prevent resending during countdown
    handleSignInSubmit(e);
    setSeconds(120); // Restart the timer
    setIsOtpSent(true); // Mark OTP as sent
  };

  const handleDobChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
    let formattedValue = rawValue;

    if (rawValue.length > 2 && rawValue.length <= 4) {
      formattedValue = `${rawValue.slice(0, 2)}/${rawValue.slice(2)}`;
    } else if (rawValue.length > 4) {
      formattedValue = `${rawValue.slice(0, 2)}/${rawValue.slice(2, 4)}/${rawValue.slice(4, 8)}`;
    }

    setFormData((prevState) => ({
      ...prevState,
      dob: formattedValue,
    }));
  };

  return (
    <div>
      <>
        {!defaultOpen &&
          (!user ? (
            <div
              className="text-base text-center font-medium bg-blue-500 shadow rounded-lg px-3 py-1
      border-2 hover:bg-blue-700 text-white cursor-pointer"
              onClick={() => setOpen(true)}
            >
              SignIn
            </div>
          ) : (
            <ProfileHoverMenu />
          ))}

        <Modal
          footer={null}
          title=""
          centered
          closable={!isSignUpMode}
          open={open}
          onOk={handleModalClose}
          onCancel={handleModalClose}
          width={900}
          maskClosable={false}
        >
          <div className="flex flex-row">
            <div className="basis-1/2 hidden sm:flex md:flex  justify-center items-center">
              {/* <img
                                src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/logo+3.png"
                                alt="Picture of the author"
                                className="p-2 w-2/5 h-1/3  "
                            /> */}
              {isSignUpMode ? (
                <img
                  src={imgS2}
                  alt="Picture of the author"
                  className="p-2 w-11/12 h-11/12"
                />
              ) : (
                <img
                  src={imgS3}
                  alt="Picture of the author"
                  className="p-2 w-11/12 h-11/12"
                />
              )}
            </div>

            <div className="w-full sm:w-1/2">
              {isLoggedIn ? (
                <>
                  {isSignUpMode ? (
                    <div className="border-l-4 rounded-md p-2 h-full">
                      <div className="p-4 text-4xl font-semibold text-center mb-2">
                        User Details
                      </div>
                      <form
                        onSubmit={handleSubmitForm}
                        // className="max-w-md mx-auto mt-8 border-2"
                        className="flex flex-col"
                      >
                        <div className="mb-4 flex justify-around">
                          <label
                            className=" text-gray-700 text-base font-bold"
                            htmlFor="fullName"
                          >
                            First Name:
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            required={true}
                            value={formData.firstName}
                            onChange={handleInputChange}
                            className="border-b-2 rounded-md border-gray-500 focus:outline-none focus:border-blue-500 px-2 text-base"
                          />
                        </div>
                        <div className="mb-4 flex justify-around">
                          <label
                            className=" text-gray-700 text-base font-bold"
                            htmlFor="fullName"
                          >
                            Last Name:
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            required={true}
                            value={formData.lastName}
                            onChange={handleInputChange}
                            className="border-b-2 rounded-md border-gray-500 focus:outline-none focus:border-blue-500 px-2 text-base"
                          />
                        </div>
                        <div className="mb-4 flex justify-around">
                          <label
                            className="text-gray-700 text-base font-bold"
                            htmlFor="dob"
                          >
                            Date Of Birth:
                          </label>
                          <input
                            type="text"
                            id="dob"
                            name="dob"
                            value={formData.dob}
                            onChange={handleDobChange}
                            maxLength={10} // Enforce the format length
                            placeholder="MM/DD/YYYY"
                            required={true}
                            className="border-b-2 rounded-md border-gray-500 focus:outline-none focus:border-blue-500 px-2 text-base"
                          />
                        </div>
                        <div className="mb-4 flex justify-around">
                          <label
                            className="text-gray-700 text-base font-bold pr-4"
                            htmlFor="gender"
                          >
                            Gender:
                          </label>
                          <div className="flex gap-2">
                            <input
                              type="checkbox"
                              id="male"
                              name="gender"
                              value="male"
                              checked={formData.gender === "male"}
                              onChange={handleInputChange}
                              className=""
                            />
                            <label htmlFor="male" className="text-base">
                              Male
                            </label>
                          </div>
                          <div className="-ml-2 flex gap-2">
                            <input
                              type="checkbox"
                              id="female"
                              name="gender"
                              value="female"
                              checked={formData.gender === "female"}
                              onChange={handleInputChange}
                              className=""
                            />
                            <label htmlFor="female" className="text-base ">
                              Female
                            </label>
                          </div>
                        </div>

                        <div className="mb-4 flex justify-around">
                          <label
                            className=" text-gray-700 text-base font-bold pr-4"
                            htmlFor="email"
                          >
                            Email:
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            required={true}
                            value={formData.email}
                            onChange={handleInputChange}
                            className=" border-b-2 rounded-md border-gray-500 focus:outline-none focus:border-blue-500 px-2 text-base"
                          />
                        </div>

                        <div className="mb-4 flex justify-around">
                          <label
                            className=" text-gray-700 text-base font-bold pr-4"
                            htmlFor="pincode"
                          >
                            Pincode:
                          </label>
                          <input
                            type="number"
                            id="pincode"
                            required={true}
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                            className=" border-b-2 rounded-md border-gray-500 focus:outline-none focus:border-blue-500 px-2 text-base"
                          />
                        </div>

                        <div className="mb-4 flex justify-center">
                          <button
                            type="submit"
                            className=" bg-blue-500 text-white py-2 px-10 rounded focus:outline-none hover:bg-blue-700 text-base"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  ) : (
                    <div className="border-l-4 rounded-md p-2 h-full">
                      <div className="p-4 text-4xl font-semibold text-center mt-3 h-3/4 flex flex-col gap-3 items-center justify-center">
                        <div className="w-16 h-16 p-4 flex items-center justify-center border-4 border-green-500 rounded-full">
                          <span className="text-green-500 text-4xl">
                            &#10003;
                          </span>
                        </div>
                        <div>
                          <div className="mb-2">Login Successful</div>
                          <div className="text-base text-gray-700">
                            You have successfully signed into your account. You
                            can close this window and continue using the
                            product.
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end items-center px-4 h-1/4 ">
                        <button
                          className="px-4 py-2 bg-blue-500 hover:bg-blue-700 font-semibold text-white rounded-md"
                          onClick={handleModalClose}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {isOtpSent ? (
                    <div className="border-l-4 rounded-md p-4 h-full">
                      {/* otp for sign in or sign up*/}
                      <div className="p-4 text-lg font-semibold text-center">
                        Enter the OTP sent to your mobile
                      </div>
                      <form
                        action=""
                        onSubmit={handleOtpSubmit}
                        className="flex flex-col items-center"
                      >
                        <div className="flex space-x-2 mb-2">
                          {/* Standard OTP input with 6 boxes */}
                          {[...Array(6)].map((_, index) => (
                            <input
                              key={index}
                              type="text"
                              maxLength="1"
                              id={`otpInput${index}`}
                              className="w-10 h-12 border border-slate-800 rounded-md text-center text-xl font-semibold focus:outline-none focus:border-blue-500"
                              onChange={(e) =>
                                handleOtpInputChange(index, e.target.value)
                              }
                              onKeyDown={(e) => handleKeyDown(index, e)}
                              name="otp"
                            />
                          ))}
                        </div>
                        <span className="text-danger">{errors.otp}</span>
                        <div className="flex gap-2">
                          {" "}
                          <p className="p-0 m-0">Didn’t receive the code?</p>
                          <button
                            className="text-blue-800"
                            disabled={allowResend}
                            onClick={handleResendOTP}
                          >
                            Resend
                          </button>
                          <p className="p-0 m-0">{seconds} Seconds</p>
                        </div>
                        <div className="mt-8 w-80 flex justify-center">
                          <button
                            onClick={switchToMobileEntry}
                            type="button"
                            className="rounded-md rounded-r-none px-6 bg-slate-400 text-sm font-medium text-white hover:bg-slate-600 focus:outline-none focus-visible:ring-2 h-12"
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="flex justify-center items-center gap-2 rounded-md rounded-l-none px-6 bg-blue-500 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none focus-visible:ring-2 h-12 disabled:opacity-50"
                            disabled={isLoading}
                          >
                            {isLoading && (
                              <CircularProgressBar
                                size={CircularProgressSize.extraSmall}
                                color="white"
                              />
                            )}
                            {isSignUpMode ? (
                              <div>Register Now</div>
                            ) : (
                              <div>Submit OTP</div>
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  ) : (
                    <div className="border-l-4 rounded-md p-4">
                      {/* mobile for sign in or sign up*/}
                      <div className="flex justify-center items-center">
                        <img
                          src={acuLogo}
                          alt="Picture of the author"
                          className="p-2 w-2/5 h-1/3"
                        />
                      </div>

                      <h3 className="p-2 mb-3 mt-4 text-center font-semibold font-sans text-3xl">
                        {!isSignUpMode ? "Sign In" : "Sign Up"}
                      </h3>
                      <div className="flex justify-center flex-col">
                        <form
                          action=""
                          onSubmit={
                            isSignUpMode
                              ? handleSignupSubmit
                              : handleSignInSubmit
                          }
                        >
                          <div className="text-center mx-auto ">
                            <div className="flex justify-center mb-1">
                              <input
                                type="tel"
                                maxLength={10}
                                placeholder="Enter Your Mobile Number"
                                onChange={handleInput}
                                name="mobile"
                                style={{
                                  width: "220px",
                                }}
                                className="rounded-md p-1 h-12 border-2 border-r-0 rounded-r-none border-slate-400 text-center"
                              />

                              <button
                                type="submit"
                                className="flex justify-center items-center gap-2 rounded-md rounded-l-none px-6 bg-blue-500 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none focus-visible:ring-2 h-12 disabled:opacity-50"
                                disabled={isLoading}
                              >
                                {isLoading && (
                                  <CircularProgressBar
                                    size={CircularProgressSize.extraSmall}
                                    color="white"
                                  />
                                )}
                                Send OTP
                              </button>
                            </div>
                            <span className="text-danger">{errors.mobile}</span>
                          </div>
                        </form>
                        <div className="flex justify-center mt-4">
                          <button
                            onClick={switchToSignupMode}
                            className="mb-6 rounded-lg px-3 py-2 border-b-2 border-blue-500 text-sm font-medium text-slate-400 focus:outline-none focus-visible:ring-2 hover:text-black"
                          >
                            {isSignUpMode
                              ? "Go back to Sign In"
                              : "Don't have account, Sign Up here"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Modal>
      </>
    </div>
  );
}

export default SignIn;
